module.exports = __webpack_public_path__ + "static/media/om_beard_stiletto_long__square_shadow.24156552.png";